module.exports = __webpack_public_path__ + "static/media/corporate-services-img18.8f629df3.jpg";